import { useQuery, useQueryClient } from "@tanstack/react-query";
import type { TaskBlock } from "../../api/generated";
import { planningListOptions, planningListQueryKey } from "../../api/generated/@tanstack/react-query.gen";
import { CHANNELS } from "../../realtime/ablyClient";
import { useChannel } from "../../realtime/useChannel";
import type { Day } from "../../utils/calendarDay";

/**
 * The time planned for tasks on `day`, kept up to date live: refetched when the day's plan
 * changes, and when any task changes, since blocks show their task's title and whether it's done.
 */
export function usePlannedBlocks(day: Day): TaskBlock[] {
  const queryClient = useQueryClient();
  const options = { query: { from: day, to: day } };
  const { data } = useQuery(planningListOptions(options));
  const refetch = () => queryClient.invalidateQueries({ queryKey: planningListQueryKey(options) });
  useChannel(CHANNELS.planning, ({ data: changed }) => {
    if ((changed as { day?: string } | undefined)?.day === day) refetch();
  });
  useChannel(CHANNELS.tasks, refetch);
  return data ?? [];
}
